<div
    class="lotam-details"
    [ngClass]="{ 'lotam-blocked': status === MissionNoticeDto.Status.BLOCK }"
>
    <div class="result-container">
        <div class="lotam-selector">
            <div class="vertical-container fill">
                <div class="fill">
                    <strong>
                        {{ lotam.subject }}
                    </strong>
                </div>
                <div class="horizontal-container wrap fill parameter-summary">
                    <div>
                        {{
                            lotam.startTime
                                | formatDateRange
                                    : lotam.endTime
                                    : organisation.timeZone
                        }}
                    </div>
                    <div>
                        {{ lotam.lowerLimit | formatAltitudeValue: 'SFC' }} -
                        {{
                            lotam.upperLimit | formatAltitudeValue: 'Unlimited'
                        }}
                    </div>
                </div>
                <div
                    class="horizontal-container vertical-align wrap fill parameter-summary top-buffer"
                >
                    <span
                        class="status-block"
                        [ngClass]="status | noticeStatusClass: isAcknowledged"
                    >
                        {{ status | formatNoticeStatusName: isAcknowledged }}
                    </span>
                    <notice-type-list-item
                        *ngIf="lotam.noticeType"
                        [noticeType]="lotam.noticeType"
                    ></notice-type-list-item>
                </div>
            </div>
            <div class="vertical-container lotam-actions-container">
                <div class="horizontal-container vertical-align">
                    <button
                        type="button"
                        class="btn btn-xs btn-pill btn-primary left-buffer"
                        tooltip="View and acknowledge LOTAM"
                        placement="top"
                        (click)="viewLotamDetail()"
                    >
                        {{ buttonText }}
                    </button>
                    <span
                        *ngIf="locationBearing != null"
                        [innerHtml]="locationBearing | bearing"
                    ></span>
                </div>
                <div
                    *ngIf="acknowledgementList.length > 0"
                    class="left-buffer acknowledgement-summary"
                >
                    <strong>Crew Acknowledgements</strong>
                    <div *ngIf="acknowledgerSummary as summary">
                        {{ summary.namesText }}
                        <button
                            *ngIf="canExpandAcknowledgers; else othersText"
                            type="button"
                            class="btn btn-link btn-xs"
                            tooltip="Show everyone who has acknowledged"
                            placement="top"
                            (click)="toggleShowAllAcknowledgers()"
                        >
                            {{ summary.othersText }}
                        </button>
                        <ng-template #othersText>
                            {{ summary.othersText }}
                        </ng-template>
                        <button
                            *ngIf="canCollapseAcknowledgers"
                            type="button"
                            class="btn btn-link btn-xs"
                            (click)="toggleShowAllAcknowledgers()"
                        >
                            Show less
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
